import {
  call, takeLatest, put, select,
} from 'redux-saga/effects';
import apiFetchRepatriationsTransactionsEdit from '../../api/RepatriationsTransactionsEditAPI';
import { REPATRIATIONS_TRANSACTIONS_EDIT_REQUEST } from '../actions/types/RepatriationsTransactionsEditActionsTypes';
import { putRepatriationsTransactionsEditSuccessActionCreator, putRepatriationsTransactionsEditFailureActionCreator } from '../actions/RepatriationsTransactionsEditActions';
import { languageSelector } from '../../../../../../../common/redux/selectors/languageSelector';
import { showNotification } from '../../../../../../../common/redux/actions/NotificationActions';
import { formatMessage } from '../../../../../../../../locales/locales';

function* doRepatriationsTransactionsEditWorker(action) {
  const lang = yield select(languageSelector);
  try {
    const res = yield call(apiFetchRepatriationsTransactionsEdit, action.payload);
    yield put(putRepatriationsTransactionsEditSuccessActionCreator(res.data));
    yield put(showNotification({
      type: 'SUCCESS',
      message: formatMessage(lang, 'notification.repatriations.transaction.edit.success'),
    }));
  } catch (error) {
    yield put(putRepatriationsTransactionsEditFailureActionCreator(error));
    yield put(showNotification({
      type: 'ERROR',
      message: formatMessage(lang, 'app.server.error'),
    }));
  }
}

function* doRepatriationsTransactionsEditWatcher() {
  yield takeLatest(REPATRIATIONS_TRANSACTIONS_EDIT_REQUEST, doRepatriationsTransactionsEditWorker);
}

export default doRepatriationsTransactionsEditWatcher;
